import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const URL_SPACES_REGEX = /\?\s*%20*/;

/**
 * Checks if we have unwanted spaces in the url between
 * the search params start symbol "?" and the first utm param
 * e.g. "app.ayblehealth.com/?%20utm_source=<affiliate>"
 * and, in that case, we remove them,
 * and we redirect users to the normalized one.
 */
export const UrlNormalizer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there is a search query and it contains unwanted spaces
    if (!location?.search.includes('%20')) return;

    // Fix only spaces between "?" and the actual query params
    const cleanedSearch = location.search.replace(URL_SPACES_REGEX, '?');

    if (location.search !== cleanedSearch) {
      navigate(`${location.pathname}${cleanedSearch}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};
